import { api } from '@/services';

export interface ListaEventosFiltro {
  TipoDocumento: string;
  ChaveAcessoDOC: string;
}

export interface EventoDocumento {
  Chave: string;
  Descricao: string;
  CodigoResposta: string;
  MensagemResposta: string;
  DocumentoAutor: string;
  DataHoraEnvio: string;
  DataHoraRecibo: string;
  DataExclusao: string | null;
  Origem: string;
}

export interface ListaEventosSimplesResponse {
  status: { resultado: boolean; mensagem: string };
  data: EventoDocumento[];
}

export async function fetchListaEventosSimples(
  filtro: ListaEventosFiltro
): Promise<ListaEventosSimplesResponse> {
  return api.post<ListaEventosSimplesResponse, ListaEventosFiltro>(
    'TurboPro/SimplesNacional/ListaEventos',
    filtro
  );
}
